module.exports = __webpack_public_path__ + "static/media/half-lux.a0c67443.jpg";